export default __webpack_public_path__ + "static/media/resources.724d7813.mp3";